import { UniformJiraPricingEntryPage } from "src/pages/uniform-entry/uniform-jira-pricing-entry-page.tsx";

import { init } from "../init-streaming";
init(UniformJiraPricingEntryPage);
